import { createSelector } from 'reselect';

import { StateDictionary } from '../reducers/utils/state-manager';

export type SourceTypeState = {
  sourceTypesById: { [sourceTypeId: number]: SourceType };
  sourceTypesStateByOrgId: StateDictionary;
};
type State = { sourceTypes: SourceTypeState };

const sourceTypesByIdSelector = (state: State) => state.sourceTypes.sourceTypesById;
const sourceTypesSelector = createSelector([sourceTypesByIdSelector], (sourceTypesById) =>
  Object.values(sourceTypesById),
);

export const sourceTypesForOrgIdSelector = createSelector(
  [sourceTypesSelector, (_state: State, orgId: number) => orgId],
  (sourceTypes, orgId) => sourceTypes.filter((s) => s.orgId === orgId || s.orgId === null),
);

export const manualSourceTypesForOrgIdSelector = createSelector(
  [sourceTypesForOrgIdSelector],
  (sourceTypes) => sourceTypes.filter((s) => s.isManualSource),
);

export const nonManualSourceTypesForOrgIdSelector = createSelector(
  [sourceTypesForOrgIdSelector],
  (sourceTypes) => sourceTypes.filter((s) => !s.isManualSource),
);

const sourceTypesStateByOrgIdSelector = (state: State) => state.sourceTypes.sourceTypesStateByOrgId;
export const sourceTypesStateForOrgIdSelector = createSelector(
  [sourceTypesStateByOrgIdSelector, (_state: State, orgId: number) => orgId],
  (sourceTypesStateByOrgId, orgId) => sourceTypesStateByOrgId[orgId],
);
